import { useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { resolveQuickReactions, ReactionLabels } from "./reactions";
import EmojiGrid from "./EmojiGrid";

type Props = {
  currentEmoji?: string;
  onSelect: (emoji: string) => void;
  labels: ReactionLabels;
  className?: string;
};

// Quick-reaction bar: the standard emojis + a "+" that swaps the view in place
// to the full emoji grid (no nested popover, no async load).
export default function ReactionQuickBar({
  currentEmoji,
  onSelect,
  labels,
  className,
}: Props) {
  const [showPicker, setShowPicker] = useState(false);

  if (showPicker) {
    return <EmojiGrid onSelect={onSelect} />;
  }

  return (
    <div
      className={classNames(
        "reactions__quickbar flex items-center gap-0.5 rounded-full border border-gray-200 bg-white px-1.5 py-1 shadow",
        className,
      )}
    >
      {resolveQuickReactions().map((emoji) => (
        <button
          key={emoji}
          type="button"
          aria-label={labels.addReaction}
          aria-pressed={currentEmoji === emoji}
          className={classNames(
            "flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-lg leading-none outline-none transition-transform hover:scale-125",
            { "bg-primary/10": currentEmoji === emoji },
          )}
          onClick={() => onSelect(emoji)}
        >
          {emoji}
        </button>
      ))}
      <button
        type="button"
        aria-label={labels.pickEmoji}
        className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-muted outline-none hover:text-normal"
        onClick={() => setShowPicker(true)}
      >
        <FontAwesomeIcon icon={faPlus} />
      </button>
    </div>
  );
}
